import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
const baseCenterBbsURL = `${baseURL}/grt-bbs-service`;

// 评论列表
export const getCommentInfoReq = (params) => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/reply', params);
};
//回复
export const replyReq = (data) => {
    return hMacAjax.post(baseCenterBbsURL + '/user/comment/reply', data);
};
//回复删除
export const delReplyReq = (id) => {
    return hMacAjax.delete(baseCenterBbsURL + '/user/comment/delete/' + id);
};

//评论配置
export const getCommentConfigReq = (params) => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/config', params);
};

//我的评论
export const getMyCommentListReq = (params) => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/my/reply', params);
};
//跳转状态

export const checkStatus = (params) => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/my/reply/check', params);
};

//获取tags
export const getTypesReq = () => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/my/reply/source');
};

//获取评论数
export const getCommentCountReq = (data) => {
    return hMacAjax.get(baseCenterBbsURL + '/user/comment/count', data);
};
